import './index.css';
import 'react-quill/dist/quill.snow.css';

import {
  CurrentStageAndConfig,
  getCurrentStageAndConfig,
} from '@amzn/rangoli-seller-desktop-async-call-wrapper/src/index';
import { currentHostName } from '@amzn/rangoli-seller-desktop-async-call-wrapper/src/StageConfig';
import { startBugsnag, notify } from '@amzn/rangoli-seller-desktop-async-call-wrapper/src/BugSnag';
import { awsRumConfig } from '@amzn/rangoli-seller-desktop-utils/src/index';
import Bugsnag from '@bugsnag/js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { CustomToaster } from '@amzn/rangoli-seller-desktop-utils/src/index';

import { Routing } from '../src/routes/routing';
import { userAuthStore } from '../src/store/UserAuthStore';
// Error boundary has to be added separately for MFE as it is causing issue while rendering
// import PreLoginLandingPage from './components/preLoginComponent/PreLoginLandingPage';
import { ENV_STAGES, ENVIRONMENT, MS_CLARITY_PROJECT_ID } from './constants/apiConstants';
import reportWebVitals from './reportWebVitals';
import Clarity from '@microsoft/clarity';

if (currentHostName === ENV_STAGES.BETA || currentHostName === ENV_STAGES.PROD) {
  Clarity.init(MS_CLARITY_PROJECT_ID[ENVIRONMENT[currentHostName]]);
}
startBugsnag();

const awsRum = awsRumConfig();

const logError = (error: Error) => {
  if (window.location.hostname === ENV_STAGES.PROD) {
    awsRum?.recordError(error);
  }
  notify(error);
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const queryClient = new QueryClient();

const mainApplication = () => {
  return (
    <React.StrictMode>
      <ErrorBoundary
        fallback={
          // Error boundary has to be added separately for MFE as it is causing issue while rendering
          <>{/* <PreLoginLandingPage error={true} isErrorBoundaryFallback={true} /> */}</>
        }
        onError={logError}
      >
        <QueryClientProvider client={queryClient}>
          <Router>
            <Routing store={userAuthStore} />
          </Router>
          <CustomToaster toasterAlignmentHorizontal="end" />
        </QueryClientProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
};

root.render(mainApplication());

reportWebVitals();
